import React from "react";

import PickupAddressCellContent from "../components/PickupAddressCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function pickupAddress({ width, language, onResize }: Column.Options) {
	return base(
		ColumnId.PickupAddress,
		(item) => <PickupAddressCellContent item={item} language={language} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default pickupAddress;
